import React, { useEffect } from "react";
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/Footer';
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import HoverLinkBtn from "../../components/common/button/HoverLinkBtn";
import CustomTitle from "../../components/common/title/CustomTitle";
import MySettingInfoTable from "../../components/mp/MySettingInfoTable";
import MySettingMemberTable from "../../components/mp/MySettingMemberTable";
import { Redirect } from "react-router-dom";
import MySettingMkTable from "../../components/mp/MySettingMkTable";
import { userInfoAction } from "../../modules/su/userInfoModule";
import { Link } from 'react-router-dom';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const MySettingBlock = styled.div``;

const MySettingWrapBlock = styled.div`
    ${isMobileOnly?`
    margin: 0 4vw; 
    padding: 120px 0 120px;    
    `:`
    padding: 140px 0 120px;
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
    `};
    

    ::after {
        content: "";
        display: block;
        clear: both;
    }
`;

const MySettingLnbBlock = styled.div`
    float: left;
    ${isMobileOnly?`
    width: 100%;     
  `:`
    width: 234px;
    padding-right: 40px;
  `};

    h2 {
        margin-bottom: 50px;
        font-size: 32px;
        font-weight: 700;
    }
`;

const MySettingLnbUlContainBlock = styled.div`
    ${isMobileOnly?`
    width: 100%;
    //overflow: scroll hidden;  
    overflow-x: scroll;
    overflow-y: hidden; 
    height: 35px;
    margin-bottom: 10vw;
    border-bottom: 1px solid #111; 
  `:`
    
  `};
`;

const MySettingLnbLiBlock = styled.li`
    margin-bottom: 30px;
    color: #333;
    font-size: 20px;
    font-weight: 500;

    ${isMobileOnly&&"float: left"};
    ${isMobileOnly&&"margin-right: 4vw"};
`;

const MySettingContentsBlock = styled.div`
    float: left;
    ${isMobileOnly?`
    width: 100%;
  `:`
    width: 936px;
  `};
`;

const MySettingTableWrapBlock = styled.div`
    width: 100%;
    border-top: 2px solid #111
    margin-bottom: 50px;

    .dt-title {
        padding-bottom: 20px;
        font-size: 18px;
        font-weight: 700;
    }
`;



const MySetting = () => {

    const dispatch = useDispatch();

    const { loading, accessToken } = useSelector(
        ({ userReducer, loadingReducer }) => ({
            registError: userReducer.registError,
            loading: loadingReducer['user/REGIST'],
            regStatus: userReducer.regStatus,
            accessToken: userReducer.accessToken
        })
    );

    useEffect(() => {
        dispatch(setCurMenuAction('mp'));
        dispatch(setHeaderTransferAction(false));
        window.scrollTo(0, 0);
    }, []);

    const menuTitle = [
        { title: '나의견적', link: '/es', isUnderLine: false },
        { title: '나의클립북', link: '/myclip', isUnderLine: false },
        { title: '회원정보관리', link: '/mysetting', isUnderLine: true },
        { title: '1:1 문의 내역', link: '/myquestion', isUnderLine: false }
    ]

    // 로그인 상태가 아니라면
    if (accessToken === null) {
        return <Redirect to="/" />
    }

    return (
        <MySettingBlock>
            <Header />
            <MySettingWrapBlock>
                <MySettingLnbBlock>
                    <h2>마이페이지</h2>
                    <MySettingLnbUlContainBlock>
                    <ul style = {isMobileOnly? {width:'max-content'}:{}}>
                        {
                            menuTitle.map((curitem, idx) => {
                                return (
                                    <MySettingLnbLiBlock key={idx}>
                                        <HoverLinkBtn
                                            text={curitem.title}
                                            bottom="2px"
                                            height="4px"
                                            link={curitem.link}
                                            isDot={false}
                                            isUnderLine={curitem.isUnderLine}
                                        >
                                        </HoverLinkBtn>
                                    </MySettingLnbLiBlock>
                                );
                            })
                        }
                    </ul>
                    </MySettingLnbUlContainBlock>
                </MySettingLnbBlock>
                <MySettingContentsBlock>
                    <CustomTitle marginBottom="58px" textColor="#333"
                        fontSize="24px" fontWeight="300" title="회원 정보 관리" textAlign="left" />

                    <MySettingTableWrapBlock>

                        <CustomTitle marginBottom="20px" textColor="#111"
                            fontSize="18px" fontWeight="700" title="로그인 정보"
                            textAlign="left" />
                        <MySettingInfoTable />

                        <CustomTitle marginBottom="20px" textColor="#111"
                            fontSize="18px" fontWeight="700" title="회원 정보"
                            textAlign="left" marginTop="50px" />
                        <MySettingMemberTable />

                        <CustomTitle marginBottom="20px" textColor="#111"
                            fontSize="18px" fontWeight="700" title="마케팅 광고 수신"
                            textAlign="left" marginTop="20px" />
                        <MySettingMkTable />
                        <div className="ess_text clearfix" style={{marginTop:'20px', color : '#666666'}}>
                            <span className="f-left"> * 서비스의 중요 안내 사항 및 주문/배송 등과 관련된 정보는 혜택 알림 수신 동의와 상관없이 발송됩니다.</span>
                            <div className="text_right" style={{marginTop:'0px'}}>
                            <Link to={"/mydrop"} className="mp_text-btn" style={{marginTop:'0px'}}>회원탈퇴</Link>
                            </div>
                        </div>



                    </MySettingTableWrapBlock>

                </MySettingContentsBlock>

            </MySettingWrapBlock>
            <Footer />
        </MySettingBlock>
    );
};

export default MySetting;
